import React from 'react';
import { useNavigate } from 'react-router-dom';

const BlogCard = ({ product }) => {
  const navigate = useNavigate();
   const prefixedMainImage = product.mainImage.startsWith('http')
    ? product.mainImage
    : `https://apiqms.shigjeta.com${product.mainImage}`;


  const handleBlogClick = () => {
    navigate(`/blog/${product.id}`);
  };

  return (
    <div className="shop-product-card" onClick={handleBlogClick}>
      <img src={prefixedMainImage} alt={product.title} />
      <h3 className="product-title">{product.title}</h3>
      <p className="product-description">{product.description}</p>
    </div>
  );
};

export default BlogCard;